import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { Camera, Film } from "lucide-react";
import ChapterHeading from "./ChapterHeading";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Gallery() {
  const [media, setMedia] = useState([]);

  useEffect(() => {
    axios.get(`${API}/media`).then(({ data }) => setMedia(data)).catch(() => {});
  }, []);

  return (
    <section id="gallery" className="px-6 sm:px-12 lg:px-24 py-20 sm:py-28" data-testid="gallery-section">
      <div className="mx-auto max-w-7xl">
        <ChapterHeading
          number="04"
          title="Gallery"
          testid="gallery-heading"
        />

        {media.length === 0 ? (
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
            className="rounded-2xl border border-dashed border-sand bg-cream/60 p-12 sm:p-20 text-center"
            data-testid="gallery-placeholder"
          >
            <div className="flex items-center justify-center gap-4 mb-6">
              <span className="w-12 h-12 rounded-full bg-panna border border-sand flex items-center justify-center">
                <Camera className="w-5 h-5 text-terracotta" />
              </span>
              <span className="w-12 h-12 rounded-full bg-panna border border-sand flex items-center justify-center">
                <Film className="w-5 h-5 text-terracotta" />
              </span>
            </div>
            <p className="font-serif text-2xl sm:text-3xl text-[#2D2A26]">
              In arrivo dopo il grande giorno
            </p>
          </motion.div>
        ) : (
          <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6" data-testid="gallery-grid">
            {media.map((m, i) => (
              <motion.div
                key={m.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.7, delay: (i % 3) * 0.1, ease: [0.16, 1, 0.3, 1] }}
                className="rounded-2xl border border-sand overflow-hidden bg-cream aspect-square"
                data-testid={`gallery-item-${i}`}
              >
                {m.kind === "video" ? (
                  <video
                    src={`${API}/media/${m.id}/file`}
                    controls
                    className="w-full h-full object-cover"
                    preload="metadata"
                    data-testid={`gallery-video-${i}`}
                  />
                ) : (
                  <img
                    src={`${API}/media/${m.id}/file`}
                    alt={m.original_filename || `Foto matrimonio ${i + 1}`}
                    className="w-full h-full object-cover transition-transform duration-[1200ms] ease-out hover:scale-105"
                    loading="lazy"
                    data-testid={`gallery-image-${i}`}
                  />
                )}
              </motion.div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
